import { render, staticRenderFns } from "./MyTickerSetting.vue?vue&type=template&id=ab320e5a&scoped=true"
import script from "./MyTickerSetting.vue?vue&type=script&lang=js"
export * from "./MyTickerSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab320e5a",
  null
  
)

export default component.exports